export const LOCAL_STORAGE = {
  REGISTRATION: {
    NON_BUYING_PHYSICIAN_REGISTRATION: 'nonBuyingPhysicianRegistration',
  },
};
